import React, { Component } from 'react'

export class CardOutline extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="col-md-12 mgt-15">
                    <h4 className="text-w-700 tcolor-black-2">Card Outline</h4>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-transparent card-outline-primary">
                        <div className='card-header'>
                            <div className="card-title">Card Outline Primary</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-transparent card-outline-secondary">
                        <div className='card-header'>
                            <div className="card-title">Card Outline Secondary</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-transparent card-outline-success">
                        <div className='card-header'>
                            <div className="card-title">Card Outline Success</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-transparent card-outline-danger">
                        <div className='card-header'>
                            <div className="card-title">Card Outline Danger</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-transparent card-outline-warning">
                        <div className='card-header'>
                            <div className="card-title">Card Outline Warning</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-transparent card-outline-info">
                        <div className='card-header'>
                            <div className="card-title">Card Outline Info</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-transparent card-outline-light">
                        <div className='card-header'>
                            <div className="card-title">Card Outline Light</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mgb-15">
                    <div className="card card-transparent card-outline-dark">
                        <div className='card-header'>
                            <div className="card-title">Card Outline Dark</div>
                        </div>
                        <div className='card-body'>
                            <p className="card-text">
                                Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default CardOutline
